import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class Users extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'user',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 10,
            phrase: '',
            filters: { role: '' }
        };
    }

    componentDidMount() { this.refreshData(); }

    refreshData(e) {
        if (e) e.preventDefault();
        this.setState({ loading: true });
        this.httpPost(`api/v1/${this.state.controllerName}/list`, {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            filters: this.state.filters
        }).then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) this.setState({ data, loading: false });
            else if (data.status === -5) window.location.href = "/access-denied";
            else { this.showErorrMessage(data.message); this.setState({ loading: false}); }
        });
    }

    confirmRemove(id) { this.setState({ id_to_remove: id }); }

    remove() {
        this.httpPost(`api/v1/${this.state.controllerName}/remove`, { id: this.state.id_to_remove })
            .then(data => {
                if (data.status === 1) {
                    this.showSuccessMessage('کاربر حذف شد');
                    this.setState({ id_to_remove: null }, () => this.refreshData());
                } else this.showErorrMessage(data.message);
            });
    }

    renderForm() {
        const { data, phrase, filters } = this.state;
        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">کاربران</h3>
                            <p className="text-soft">{data?.recordsCount || 0} کاربر</p>
                        </div>
                        <div className="nk-block-head-content">
                            <NavLink to="/user/new/" className="btn btn-primary"><em className="icon ni ni-user-plus"></em> کاربر جدید</NavLink>
                        </div>
                    </div>
                </div>

                <div className="card card-bordered mb-3">
                    <div className="card-inner">
                        <form onSubmit={e => this.refreshData(e)}>
                            <div className="row g-3 align-items-end">
                                <div className="col-md-4">
                                    <label className="form-label">جستجو</label>
                                    <input type="text" className="form-control" value={phrase}
                                        onChange={e => this.setState({ phrase: e.target.value })} placeholder="نام یا موبایل" />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">نقش</label>
                                    <select className="form-select" value={filters.role}
                                        onChange={e => this.setState({ filters: { ...filters, role: e.target.value } })}>
                                        <option value="">همه</option>
                                        <option value="1">مدیر</option>
                                        <option value="2">سرپرست</option>
                                        <option value="3">حسابدار</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <button type="submit" className="btn btn-primary">اعمال</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="card card-bordered card-stretch">
                    {data?.records?.length > 0 ? (
                        <div className="card-inner p-0">
                            <table className="table table-bordered">
                                <thead>
                                    <tr><th>نام کامل</th><th>موبایل</th><th>نقش</th><th>فعال</th><th>عملیات</th></tr>
                                </thead>
                                <tbody>
                                    {data.records.map(u => (
                                        <tr key={u.id}>
                                            <td>{u.fullName}</td>
                                            <td>{u.mobile}</td>
                                            <td><span className={`badge ${u.roleString === 'مدیر' ? 'badge-danger' : u.roleString === 'سرپرست' ? 'badge-warning' : 'badge-info'}`}>{u.roleString}</span></td>
                                            <td>{u.isActive ? '✓' : '✗'}</td>
                                            <td>
                                                <NavLink to={`/user/edit/${u.id}/`} className="btn btn-sm btn-primary"><em className="icon ni ni-edit"></em></NavLink>
                                                <button className="btn btn-sm btn-danger ml-1" onClick={() => this.confirmRemove(u.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-trash"></em></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {this.createPaging()}
                        </div>
                    ) : (
                        <div className="card-inner"><div className="alert alert-info">هیچ کاربری یافت نشد.</div></div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            this.getGlobalContainer(),
            <Header data={this.state.data} />,
            <div className="nk-content"><div className="container-fluid"><div className="nk-content-inner">{this.renderForm()}</div></div></div>,
            <Footer />
        ];
        return contents;
    }
}